import { Outlet, createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { AreaSidebar, ProductGuard, ProductLayout } from '@/app/routes/area-layout'

export function SettingsLayout() {
  return (
    <ProductGuard product="settings">
      <ProductLayout sidebar={<AreaSidebar area="settings" />}>
        <Outlet />
      </ProductLayout>
    </ProductGuard>
  )
}

export const settingsRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'settings',
  component: SettingsLayout,
})
